import type { News } from "epsm-api-types/models";

export function getNewsType({ data }: { data: News }) {
	if (!data) return;
	if (data.briefs?.length) return "Brief";
	if (data.dataset === "news") return "News";
	if (data.dataset === "events") return "Top";
}
